import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from "@angular/core";

import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {
  FullProblemTemplate
} from "../../../../admin/feature/contentViewer/problemTemplatePreview/problemTemplatePreview.component";
import _ from "lodash";
import {debounceTime, fromEvent} from "rxjs";

@Component({
    selector: 'text-area',
    styleUrls: ['../../../../admin/feature/userManagement/userRoleAddEdit/userRoleAddEdit.css'],
    imports: [FontAwesomeModule, FormsModule, MatCheckboxModule],
    templateUrl: './textarea.component.html'
})
export class TextareaComponent implements AfterViewInit{
  @Input('review') review: boolean = false;
  @Input('problem_template') problem_template!: FullProblemTemplate
  @Input('answer') answer?: string = ''
  @Output() answerChange = new EventEmitter<string>()
  @Output() onChangeEmitter = new EventEmitter<Function>()
  @ViewChild('textAreaElement') textArea: ElementRef | undefined;

  ngAfterViewInit() {
    fromEvent(this.textArea?.nativeElement, 'input').pipe(
      debounceTime(300)
    ).subscribe(() => {
      if(this.answer != undefined) {
        this.answerChange.emit(this.answer)
        this.onChangeEmitter.emit(this.onChangeEmitter)
      }
    });
  }
}
